import { eventFactory } from '@ral/utils:core/events';

/**
 *  @deprecated
 */
export const [injectLocalDialogCloseEvent, injectLocalDialogCloseEmitter] = eventFactory<void>();
